module.exports = __webpack_public_path__ + "img/Gallery_1_10.40bcf239.jpeg";